import { Plus, Sparkles } from "lucide-react";
import { Button } from "./ui/button";

export const EmptyState = ({ onCreate, filter }) => {
  const title =
    filter === "all"
      ? "Your workspace is quiet"
      : `Nothing in ${filter === "in-progress" ? "In Progress" : filter === "todo" ? "Todo" : "Done"} yet`;
  const subtitle =
    filter === "all"
      ? "Capture the first thing on your mind. Small steps make big progress."
      : "Tasks will appear here when they match this filter.";

  return (
    <div
      data-testid="empty-state"
      className="relative overflow-hidden rounded-2xl border border-dashed border-slate-300 dark:border-slate-700 bg-white/60 dark:bg-[#181E2C]/60 p-10 md:p-14 text-center"
    >
      <div className="mx-auto h-14 w-14 rounded-2xl bg-indigo-50 dark:bg-indigo-500/15 text-indigo-600 dark:text-indigo-300 flex items-center justify-center">
        <Sparkles className="h-7 w-7" />
      </div>
      <h3 className="mt-5 font-display text-2xl font-semibold text-slate-900 dark:text-slate-100">{title}</h3>
      <p className="mt-2 text-sm text-slate-500 dark:text-slate-400 max-w-md mx-auto leading-relaxed">
        {subtitle}
      </p>
      {filter === "all" && (
        <Button
          onClick={onCreate}
          data-testid="empty-create-btn"
          className="mt-6 rounded-full h-11 px-6"
        >
          <Plus className="h-4 w-4 mr-2" />
          Create your first task
        </Button>
      )}
    </div>
  );
};
